export default __webpack_public_path__ + "static/media/swipeB.b932aea9.svg";